
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as myGlobals from '../globals';
import { ConfigService } from '../config.service';
// import { ConfigService } from '../config.service';

declare var jQuery: any;

@Injectable()
export class LoginService {
    // dispatcher
    private _loginUrl = myGlobals.apiurl + 'dispatcher/signIn';

    constructor(
        private _router: Router,
        private _http: HttpClient,
        private _conf: ConfigService
    ) { }

    login(user: any) {
        let body = JSON.stringify(user);
        return this._http.post(this._loginUrl, body, { headers: this._conf.header }).pipe(
            map((res) => {
                jQuery('.lds-dual-ring').show();
                return res;
            }));
    }
}